var map = {
	"./locale-provider/bg_BG.tsx": 894,
	"./locale-provider/ca_ES.tsx": 895,
	"./locale-provider/cs_CZ.tsx": 896,
	"./locale-provider/de_DE.tsx": 897,
	"./locale-provider/en_GB.tsx": 898,
	"./locale-provider/en_US.tsx": 899,
	"./locale-provider/es_ES.tsx": 900,
	"./locale-provider/et_EE.tsx": 901,
	"./locale-provider/fi_FI.tsx": 902,
	"./locale-provider/fr_BE.tsx": 903,
	"./locale-provider/fr_FR.tsx": 904,
	"./locale-provider/it_IT.tsx": 905,
	"./locale-provider/ja_JP.tsx": 906,
	"./locale-provider/ko_KR.tsx": 907,
	"./locale-provider/nl_BE.tsx": 908,
	"./locale-provider/nl_NL.tsx": 909,
	"./locale-provider/pl_PL.tsx": 910,
	"./locale-provider/pt_BR.tsx": 911,
	"./locale-provider/ru_RU.tsx": 912,
	"./locale-provider/sk_SK.tsx": 913,
	"./locale-provider/sv_SE.tsx": 915,
	"./locale-provider/tr_TR.tsx": 916,
	"./locale-provider/vi_VN.tsx": 917,
	"./locale-provider/zh_TW.tsx": 918
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 850;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 850
// module chunks = 0